/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import moment from 'moment';
import api from './api';

const name = 'coupons';

const getCouponConfig = createAsyncThunk(
  'coupons/getMerchantCouponConfig',
  async () => {
    const response = await api.getMerchantCouponConfig();
    return response;
  }
);

const setCouponConfig = createAsyncThunk(
  'coupons/setMerchantCouponConfig',
  async (payload, { rejectWithValue }) => {
    try {
      return await api.setMerchantCouponConfig(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const setImageCouponConfig = createAsyncThunk(
  'coupons/setImageCouponConfig',
  async (payload) => {
    const response = await api.setImageCouponConfig(payload);
    return response;
  }
);

const getCouponPlanList = createAsyncThunk(
  'coupons/getCouponPlanList',
  async (payload) => {
    const response = await api.getCouponPlanList(payload);
    return response;
  }
);
const getCouponCampaignList = createAsyncThunk(
  'coupons/getCouponCampaignList',
  async (payload) => {
    const response = await api.getCouponCampaignList(payload);
    return response;
  }
);

const getCouponList = createAsyncThunk(
  'coupons/getCouponList',
  async (payload) => {
    const response = await api.getCouponList(payload);
    return response;
  }
);
const downloadCouponCSV = createAsyncThunk(
  'coupons/downloadCouponCSV',
  async (params) => {
    const response = await api.getCouponList({ ...params, limit: 99999 });
    return response;
  }
);

const createCouponPlan = createAsyncThunk(
  'coupons/createCouponPlan',
  async (payload) => {
    const response = await api.createCouponPlan(payload);
    return response;
  }
);
const createOrUpdateCouponCampaign = createAsyncThunk(
  'coupons/createCouponCampaign',
  async (payload) => {
    const response = await api.createCouponCampaign(payload);
    return response;
  }
);

const createSingleCoupon = createAsyncThunk(
  'coupons/createSingleCoupon',
  async (payload) => {
    const response = await api.createSingleCoupon(payload);
    return response;
  }
);
const sendSingleCoupon = createAsyncThunk(
  'coupons/sendSingleCoupon',
  async (payload) => {
    const response = await api.sendSingleCoupon(payload);
    return response;
  }
);

const deleteCouponPlan = createAsyncThunk(
  'coupons/deleteCouponPlan',
  async (payload) => {
    const response = await api.deleteCouponPlan(payload);
    return response;
  }
);
const deleteCouponCampaign = createAsyncThunk(
  'coupons/deleteCouponCampaign',
  async (payload) => {
    const response = await api.deleteCouponCampaign(payload);
    return response;
  }
);

const resendEmail = createAsyncThunk('coupons/resendEmail', async (id) => {
  const response = await api.resendEmail(id);
  return response;
});

const cancel = createAsyncThunk('coupons/cancel', async (id) => {
  const response = await api.cancel(id);
  return response;
});

const getRedemptions = createAsyncThunk(
  '/coupons/redemptions',
  async (payload) => {
    const response = await api.getRedemptions(payload);
    return response;
  }
);

const getMembershipPlanCouponCampaigns = createAsyncThunk(
  '/coupons/getMembershipPlanCouponCampaigns',
  async (payload) => {
    const response = await api.getMembershipPlanCouponCampaigns(payload);
    return response;
  }
);

const postMembershipPlanCouponCampaigns = createAsyncThunk(
  'coupons/postMembershipPlanCouponCampaigns',
  async (payload) => {
    const response = await api.postMembershipPlanCouponCampaigns(payload);
    return response;
  }
);
const getLoyaltyProgramCouponCampaigns = createAsyncThunk(
  '/coupons/getLoyaltyProgramCouponCampaigns',
  async (payload) => {
    const response = await api.getLoyaltyProgramCouponCampaigns(payload);
    return response;
  }
);

const postLoyaltyProgramCouponCampaigns = createAsyncThunk(
  'coupons/postLoyaltyProgramCouponCampaigns',
  async (payload) => {
    const response = await api.postLoyaltyProgramCouponCampaigns(payload);
    return response;
  }
);

const getReportCouponCampaigns = createAsyncThunk(
  'coupons/getReportCouponCampaigns',
  async (payload) => {
    const response = await api.getReportCouponCampaignsApi(payload);
    return response;
  }
);

const getCouponCampaignsHistory = createAsyncThunk(
  'coupons/getCouponCampaignsHistory',
  async (payload) => {
    const response = await api.getCouponCampaignsHistoryApi(payload);
    return response;
  }
);

const updatePlanStatus = createAsyncThunk(
  'coupons/updatePlanStatus',
  async (payload) => {
    const response = await api.updatePlanStatusApi(payload);
    return response;
  }
);

const getVoucherDesigns = createAsyncThunk('coupons/getVoucherDesigns', () =>
  api.getVoucherDesigns()
);
const saveVoucherDesign = createAsyncThunk(
  'coupons/saveVoucherDesign',
  (payload) => api.saveVoucherDesign(payload)
);
const reorderVoucherDesigns = createAsyncThunk(
  'coupons/reorderVoucherDesigns',
  (payload) => api.reorderVoucherDesigns(payload)
);
const updateVoucherDesignStatus = createAsyncThunk(
  'coupons/updateVoucherDesignStatus',
  (payload) => api.updateVoucherDesignStatus(payload)
);
const deleteVoucherDesign = createAsyncThunk(
  'coupons/deleteVoucherDesign',
  (id) => api.deleteVoucherDesign(id)
);
const getVoucherConfigs = createAsyncThunk(
  'coupons/getVoucherConfigs',
  (params) => api.getVoucherConfigs(params)
);
const saveVoucherConfig = createAsyncThunk(
  'coupons/saveVoucherConfig',
  (payload) => api.saveVoucherConfig(payload)
);
const deleteVoucherConfig = createAsyncThunk(
  'coupons/deleteVoucherConfig',
  (id) => api.deleteVoucherConfig(id)
);
const getCouponOrder = createAsyncThunk('coupons/getCouponOrder', (id) =>
  api.getCouponOrder(id)
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      configs: {},
      isLoading: false,
      imgIsLoading: false,
      plans: [],
      totalPlans: 0,
      checkIn: [],
      campaigns: { data: [], total: 0 },
      coupons: { data: [], total: 0 },
      redemptions: { data: [], total: 0 },
      couponCampaigns: [],
      campaignsHistory: [],
      error: null,
      csv: [],
    },
    extraReducers: {
      [getCouponConfig.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getCouponConfig.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        configs: getOr(null, 'payload', action),
      }),
      [getCouponConfig.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),

      [setCouponConfig.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [setCouponConfig.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        configs: getOr(null, 'payload', action),
      }),
      [setCouponConfig.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),

      [setImageCouponConfig.pending]: (state) => ({
        ...state,
        imgIsLoading: true,
      }),
      [setImageCouponConfig.fulfilled]: (state) => ({
        ...state,
        imgIsLoading: false,
      }),
      [setImageCouponConfig.rejected]: (state, payload) => ({
        ...state,
        imgIsLoading: false,
        error: payload,
      }),

      [getCouponPlanList.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getCouponPlanList.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        plans: getOr([], 'payload.data', action),
        totalPlans: getOr(0, 'payload.total', action),
      }),
      [getCouponPlanList.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getCouponCampaignList.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getCouponCampaignList.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        campaigns: getOr([], 'payload', action),
      }),
      [getCouponCampaignList.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getCouponList.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getCouponList.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        coupons: getOr({ total: 0, data: [] }, 'payload', action),
      }),
      [getCouponList.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [downloadCouponCSV.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        csv: getOr([], 'payload.data', action).map((r) => ({
          'Issue Date': moment(`${r.createdAt}Z`).format(
            'MMM DD YYYY, HH:mm:ss'
          ),
          Source: r.couponOrderId ? 'Sold' : 'Issued',
          'Order ID': r.orderNumber || '',
          'Price Paid': r.pricePaid ?? '',
          'First Name': r.firstName,
          'Last Name': r.lastName,
          Email: r.email,
          'Coupon Code': r.code,
          'Max Redemptions': r.maxRedemptions === -1 ? '' : r.maxRedemptions,
          Redemptions: r.redemptions,
          Balance:
            r.maxRedemptions !== -1 ? r.maxRedemptions - r.redemptions : '',
          'Expiration Date': r.expirationDate
            ? moment(`${r.expirationDate}Z`).format('MMM DD YYYY, HH:mm:ss')
            : '',
          'Discount Name': r.couponPlan.name,
          'Discount Description': r.discount,
          'Campaign Name': r.description,
        })),
      }),
      [getRedemptions.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getRedemptions.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        redemptions: getOr({ total: 0, data: [] }, 'payload', action),
      }),
      [getRedemptions.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getMembershipPlanCouponCampaigns.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getMembershipPlanCouponCampaigns.fulfilled]: (state) => ({
        ...state,
        isLoading: false,
      }),
      [getMembershipPlanCouponCampaigns.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getLoyaltyProgramCouponCampaigns.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getLoyaltyProgramCouponCampaigns.fulfilled]: (state) => ({
        ...state,
        isLoading: false,
      }),
      [getLoyaltyProgramCouponCampaigns.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getReportCouponCampaigns.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getReportCouponCampaigns.fulfilled]: (state, action) => ({
        ...state,
        couponCampaigns: getOr({ total: 0, data: [] }, 'payload', action),
        isLoading: false,
      }),
      [getReportCouponCampaigns.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getCouponCampaignsHistory.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getCouponCampaignsHistory.fulfilled]: (state, action) => ({
        ...state,
        campaignsHistory: getOr({ total: 0, data: [] }, 'payload', action),
        isLoading: false,
      }),
      [getCouponCampaignsHistory.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
    },
  }),
};

const selectors = {
  selectCouponConfig: (state) => getOr({}, 'configs', state[name]),
  selectCouponList: (state) =>
    getOr({ data: [], total: 0 }, 'coupons', state[name]),
  selectIsLoading: (state) => getOr({}, 'isLoading', state[name]),
  selectCsv: (state) => getOr({}, 'csv', state[name]),
  selectImgIsLoading: (state) => getOr(false, 'imgIsLoading', state[name]),
  selectCouponPlans: (state) => getOr([], 'plans', state[name]),
  selectCouponCampaigns: (state) =>
    getOr([{ data: [], total: 0 }], 'campaigns', state[name]),
  selectCouponPlansTotal: (state) => getOr(0, 'totalPlans', state[name]),
  selectRedemptionList: (state) =>
    getOr({ data: [], total: 0 }, 'redemptions', state[name]),
  selectReportCampaigns: (state) => getOr([], 'couponCampaigns', state[name]),
  selectCampaignsHistory: (state) => getOr([], 'campaignsHistory', state[name]),
};

export default {
  actions: {
    ...actions,
    getCouponConfig,
    setCouponConfig,
    setImageCouponConfig,
    getCouponPlanList,
    getCouponCampaignList,
    getCouponList,
    createCouponPlan,
    createOrUpdateCouponCampaign,
    deleteCouponPlan,
    deleteCouponCampaign,
    downloadCouponCSV,
    createSingleCoupon,
    sendSingleCoupon,
    resendEmail,
    cancel,
    getRedemptions,
    getMembershipPlanCouponCampaigns,
    postMembershipPlanCouponCampaigns,
    getLoyaltyProgramCouponCampaigns,
    postLoyaltyProgramCouponCampaigns,
    getReportCouponCampaigns,
    getCouponCampaignsHistory,
    updatePlanStatus,
    getVoucherDesigns,
    saveVoucherDesign,
    reorderVoucherDesigns,
    updateVoucherDesignStatus,
    deleteVoucherDesign,
    getVoucherConfigs,
    saveVoucherConfig,
    deleteVoucherConfig,
    getCouponOrder,
    ///
  },
  selectors,
  reducer,
  name,
};
